import { TextField } from '@/ui/form/controls/TextField'
import * as React from 'react'
import { useDriverForm } from '@/modules/drivers/context/DriverFormContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { Divider } from '../../shared/Divider'

const ContactStage = () => {
  const { t } = useLocalize()
  const { data, setData, countriesOptions, countries } = useDriverForm()

  return (
    <div className="tw-flex tw-justify-between">
       <div className="tw-w-full tw-max-w-[256px]">
        <p className="tw-text-lg tw-font-semibold tw-text-content-base">
        Dane kontaktowe
        </p>
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        <TextField
          label={t('common.address')}
          placeholder={t('common.type')}
          value={data?.address}
          onChange={(e) => setData({ ...data, address: e.target.value })}
        />
        <div className="tw-flex tw-gap-4">
          <TextField
            label={t('common.city')}
            placeholder={t('common.type')}
            value={data?.city}
            onChange={(e) => setData({ ...data, city: e.target.value })}
          />
          <TextField
            label={t('driverBasics.postal-code')}
            placeholder={t('common.type')}
            value={data?.postalCode}
            onChange={(e) => setData({ ...data, postalCode: e.target.value })}
          />
        </div>
        <FieldsetSelect
          label={t('common.country')}
          placeholder={t('common.select')}
          value={data?.country?.id.toString() ?? ''}
          name={'country'}
          onChange={(e) => {
            const id = e.target.value

            const countryObj = Array.isArray(countries)
              ? countries.find((c) => c.id.toString() === id)
              : null

            setData({
              ...data,
              country: countryObj ?? null,
            })
          }}
          options={countriesOptions}
        />

        <Divider />
        <TextField
          label={t('common.phone')}
          placeholder={t('common.type')}
          value={data?.phoneNumber}
          onChange={(e) => setData({ ...data, phoneNumber: e.target.value })}
        />
        <TextField
          label={t('common.email')}
          placeholder={t('common.type')}
          value={data?.email}
          onChange={(e) => setData({ ...data, email: e.target.value })}
        />
      </div>
    </div>
  )
}

export default ContactStage
